import { ICellRendererParams } from 'ag-grid-community';
import { FC } from 'react';
import { NumberTag } from '@aleph/shared-components';
import { EventTrackerType } from 'wb-reddit/graphql/generated';
import { useTranslation } from 'react-i18next';

export interface IUrlsCellRendererParams extends ICellRendererParams {
	eventTrackerType: EventTrackerType;
	showEmpty: boolean;
}

const UrlsCellRenderer: FC<IUrlsCellRendererParams> = (params) => {
	const { t } = useTranslation();
	const trackers = params.value ?? [];

	return (
		<div className="flex h-full px-[8px] justify-between items-center gap-2">
			<div className="overflow-hidden">
				<div
					className="overflow-hidden overflow-ellipsis"
					style={{ width: 'calc(100% + 1px)' }}
				>
					{trackers.length > 0
						? trackers.map(tracker => tracker.url).join(', ')
						: <span className='text-gray-500'>{t('sc: enter url', 'Enter one or more URLs')}</span>
					}
				</div>
			</div>

			<div className="flex items-center gap-2">
				{trackers?.length > 1 && <NumberTag count={trackers.length} />}
			</div>
		</div>
	);
};

export default UrlsCellRenderer;
